/** Blue used for the "855" prefix in 855WhoDoICall branding across all packages. */
export const BRAND_855_BLUE = "#1890FF";

const palette = {
  primary: {
    main: BRAND_855_BLUE,
  },
  secondary: {
    main: "#FF5996",
  },
  success: {
    main: "#54D62C",
  },
  waring: {
    main: "#FFC107",
  },

  black: "#000000",
  blackOne: "#212B36",
  blackTwo: "#637381",
  blackThree: "#212B36",
  blackFour: "#637381",
  blackFive: "rgba(145, 158, 171, 0.24)",
  blackSix: "rgba(51, 102, 255, 0.08)",
  light: "#637381",
  lightOne: "#919EAB",
  lightTwo: "#F4F6F8",
  lightThree: "#DFE3E8",
  borderLight: "rgba(145, 158, 171, 0.32)",
  blue: "#0C53B7",
  blueOne: "#DAEDFF",
  blueDark: "#D0F2FF",
  blueDarkOne: "#04297A",
  main: "#54D62C",
  lightColor: "rgba(0, 0, 0, 0.54)",
  lightColorTwo: "rgba(27, 15, 56, 0.07)",
  lightColorThree: "rgba(0, 0, 0, 0.87)",
  lightBorderColor: "#EFEEF1",
  lightBorderColorTwo: "#E0E0E0",
  lightBorderColorThree: "#eeeeee52",
  lightBlack: "#888298",
  lightFour: "#A1A1A1",
  lightFive: "#898298",
  lightSix: "#F5F5F5",
  lightSeven: "rgba(25, 55, 101, 0.05)",
  lightEight: "rgba(255, 255, 255, 0.003)",
  lightNine: "rgba(255, 89, 150, 0.1)",
  lightTen: "rgb(236, 243, 242)",
  dark: "#C4C4C4",
  danger: "#D32F2F",
  pink: "#CC4778",
  white: "#FFFFFF",
  redDev: "#F5F7F8",
  lightGray: "rgba(0, 0, 0, 0.12)",
  green: "#0CC72A",
  greenOne: "#54D62C",
  red: "#FF4842",
  redTwo: "rgb(252, 94, 94)",
  darkRed: "#771117",
  tooltipBackground: "rgba(97,97,97,0.92)",
  bodyBackground: "#F8F8F9",
  offWhite: "#F5F5F5",
  yellow: "#ed6c02",
  editorBorder: "#F1F1F1",
  lightLeftBorder: "#e2e2e2",
  lightPink2: "rgb(255, 89, 150)",
  lightBackground: "rgba(0, 0, 0, 0.2)",
  lightYellow: "#fdd835",
};

export default palette;
